<script setup lang="ts">
import type { ComboboxContentEmits, ComboboxContentProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { ComboboxContent, ComboboxPortal, ComboboxViewport, useForwardPropsEmits } from 'reka-ui';

// virtualized: skip ComboboxViewport so a ComboboxVirtualizer child sits directly under the scrollable content (its scroll parent).
const props = withDefaults(
  defineProps<ComboboxContentProps & { class?: HTMLAttributes['class']; virtualized?: boolean }>(),
  {
    position: 'popper',
    align: 'center',
    sideOffset: 4,
  },
);
const emits = defineEmits<ComboboxContentEmits>();

const delegatedProps = reactiveOmit(props, 'class', 'virtualized');

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
  <ComboboxPortal>
    <ComboboxContent
      v-bind="forwarded"
      :class="
        cn(
          'z-50 max-h-96 overflow-y-auto rounded-md border bg-popover text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
          position === 'popper' && 'min-w-[--reka-combobox-trigger-width]',
          props.class,
        )
      "
    >
      <slot name="header" />
      <ComboboxViewport v-if="!virtualized">
        <slot />
      </ComboboxViewport>
      <slot v-else />
    </ComboboxContent>
  </ComboboxPortal>
</template>
